module.exports = __webpack_public_path__ + "img/banner-dark.11efbc23.webp";